import React from "react";
import styled from "styled-components/macro";
import { Spinner } from "@src/components/elements/Spinner";
const StyledRoot = styled.div`
  .banner {
    border-radius: var(--rounded-corner);
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    color: var(--secondary-black);

    @media (max-width: 1000px) {
      width: 100%;
    }
  }
`;

interface Props {
  description: string;
  header: string;
}

export const LoadingBox: React.FC<Props> = ({ description, header }) => {
  return (
    <StyledRoot>
      <h1>{header}</h1>
      <div className="banner">
        <Spinner />
        <h4>{description}</h4>
      </div>
    </StyledRoot>
  );
};
